module.exports = __webpack_public_path__ + "static/img/logo.57731e67.svg";